import { useCallback } from 'react'
import React from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { IPaletteProps } from 'components/uiKit/ColorPicker'
import { Palette } from 'components/uiKit/ColorPicker'

const FieldPalette = ({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<IPaletteProps, string>) => {
  const handleChange = useCallback((value: string) => onChange({ name, value }), [name, onChange])

  return <Palette {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldPalette) as typeof FieldPalette
